import { useNavigateTo } from '../../paths/useNavigateTo';
import { path } from '../../paths';
import { Forbidden } from '../Forbidden';
import { AccessGroupForm } from './AccessGroupForm';
import { useCallback } from 'react';
import { AccessGroupDto, useIsAdmin } from '@atlas-frontend/sdk';

export const AccessGroupCreate = () =>
  !useIsAdmin() ? <Forbidden /> : <AccessGroupCreateInner />;

export const AccessGroupCreateInner = () => {
  const navigateToAccessGroupDirectory = useNavigateTo(
    path.accessGroupDirectory
  );
  const navigateToAccessGroupEdit = useNavigateTo(path.accessGroupEdit);

  const handleCancel = useCallback(() => {
    navigateToAccessGroupDirectory();
  }, [navigateToAccessGroupDirectory]);
  const handleSuccess = useCallback(
    (response: AccessGroupDto) => {
      navigateToAccessGroupEdit(
        { id: response.id },
        { state: { saved: 'success', noBlocker: true } }
      );
    },
    [navigateToAccessGroupEdit]
  );

  return (
    <AccessGroupForm
      mode="create"
      onClickCancel={handleCancel}
      onSuccess={handleSuccess}
      defaultValues={defaultAccessGroup}
    />
  );
};

const defaultAccessGroup: AccessGroupDto = {
  id: '' as any,
  name: '',
  description: '',
  createdAt: null,
  createdBy: null,
  modifiedAt: null,
  modifiedBy: null,
};
